export class EventPathParam {

  constructor(public Oid : number | null, public Type : EventTypeEnum | null) { }

  public static create = (oid : number | null, type : EventTypeEnum | null): EventPathParam => new EventPathParam(oid, type);

}

export enum EventTypeEnum {

  NotSet = 0,
  LEAD = 1,
  WORKORDER = 2,
  ORDER = 3,
  SCHEDULER = 4,
  CUSTOMER  = 5,
  QUOTATION = 6,

}
